// LanguageContext.js

import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [isEnLang, setIsEnLang] = useState(false);

    const toggleLanguage = () => {
        setIsEnLang(!isEnLang);
    };

    return (
        <LanguageContext.Provider value={{ isEnLang, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
